import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { FiTwitter, FiLinkedin, FiGithub, FiMail, FiLink } from "react-icons/fi";
import { FcGoogle } from "react-icons/fc"

const containerVariants = {
    initial: {
        x: '-100vw',
        opacity: 0,
    },
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring'
        }
    },
    exit: {
        x: '50vw',
        opacity: 0,
        transition: {
            duration: 0.5
        }
    }
}

const contactBoxContainerVariant = {
    initial: {
        x: '-100vw',
        opacity: 0,
    },
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            staggerChildren: 0.5,
            type: 'spring'
        }
    }
}
const contactBoxVariant = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: {
            type: 'spring'
        }
    },
    hover: {
        scale: 1.1
    }
}

const Contact = () => {
    return (
        <motion.section id='contact'
            variants={containerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            <Container>
                <Row>
                    <Col xs={12} lg={5}>
                        <h2 className="text-left font-weight-bold">Get in Touch</h2>
                        <motion.div className='contact-box-container'
                            variants={contactBoxContainerVariant}
                        >
                            <motion.div
                                className="contact-box"
                                variants={contactBoxVariant}
                                whileHover='hover'
                            >   
                                <Row>
                                    <Col xs={2}>
                                        <FiMail size={35} color='#177cff' />
                                    </Col>
                                    <Col xs={10}>
                                        <div>Mail:</div>
                                        <div className='contact-info'><FcGoogle /> @itsvishal.codes</div>
                                    </Col>
                                </Row>
                            </motion.div>
                            <motion.div
                                className="contact-box"
                                variants={contactBoxVariant}
                                whileHover='hover'
                            >
                                <Row>
                                    <Col xs={2}>
                                        <FiLinkedin size={35} color='#177cff' />
                                    </Col>
                                    <Col xs={10}>
                                        <div>LinkedIn:</div>
                                        <div className='contact-info'> @itsvishalcodes</div>
                                    </Col>
                                </Row>
                            </motion.div>
                            <motion.div
                                className="contact-box"
                                variants={contactBoxVariant}
                                whileHover='hover'
                            >
                                <Row>
                                    <Col xs={2}>
                                        <FiGithub size={35} color='#177cff' />
                                    </Col>
                                    <Col xs={10}>
                                        <div>Github:</div>
                                        <div className='contact-info'> @itsvishalcodes</div>
                                    </Col>
                                </Row>
                            </motion.div>
                            <motion.div
                                className="contact-box"
                                variants={contactBoxVariant}
                                whileHover='hover'
                            >
                                <Row>
                                    <Col xs={2}>
                                        <FiTwitter size={35} color='#177cff' />
                                    </Col>
                                    <Col xs={10}>
                                        <div>Twitter:</div>
                                        <div className='contact-info'> @itsvishalcodes</div>
                                    </Col>
                                </Row>
                            </motion.div>
                        </motion.div>
                    </Col>
                    <div style={{height: '100px', width: '100vw'}} className="d-block d-lg-none"></div>
                    <Col xs={12} lg={7}>
                        <h2 className="text-left font-weight-bold">Let me know you were here...</h2>
                        <div className='contact-form-container'>

                        </div>
                        <Form>
                            <Form.Row>
                                <Col xs={12} lg={6}>
                                    <Form.Control type="name" placeholder="Your Name*" />
                                </Col>

                                <Col xs={12} lg={6}>
                                    <Form.Control type="email" placeholder="Your EMail*" />
                                </Col>
                            </Form.Row>

                            <Form.Row>
                                <Col xs={12} lg={6}>
                                    <Form.Control type="text" placeholder="Subject*" />
                                </Col>

                                <Col xs={12} lg={6}>
                                    <Form.Control type="text" placeholder="Phone*" />
                                </Col>
                            </Form.Row>

                            <Form.Row>
                                <Col xs={12}>
                                    <Form.Control placeholder="Your Message*" as="textarea" rows={5} />
                                </Col>
                            </Form.Row>

                            <Button variant="outline-success" type="submit">
                                Submit
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </motion.section>
    )
}

export default Contact